import { supabase, Tables } from '@/lib/supabase';

export type GetSubprojectInvitationInput = {
  invitationToken: string;
};

export type GetSubprojectInvitationResult =
  Tables<'contractor_subproject_invitation'> & {
    project: Tables<'projects'> | null;
    inviter: Tables<'profiles'> | null;
  };

export const getSubprojectInvitation = async ({
  invitationToken,
}: GetSubprojectInvitationInput): Promise<GetSubprojectInvitationResult> => {
  const { data, error } = await supabase
    .from('contractor_subproject_invitation')
    .select(
      '*, project:projects(*), inviter:profiles!contractor_subproject_invitation_inviter_id_fkey(*)',
    )
    .eq('invitation_token', invitationToken)
    .single();

  if (error) {
    throw error;
  }

  return data;
};
